module.exports = __webpack_public_path__ + "static/img/insurance_commpany.f043edb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/insurance_commpany.png
// module id = voNl
// module chunks = 1